require('./ng-juxtapose');
module.exports = 'ng-juxtapose';



//////////////////
// WEBPACK FOOTER
// ./~/ng-juxtapose/src/index.js
// module id = 17
// module chunks = 0